import './SearchCancelBilling.css'

const SearchCancelBilling = ({ search, setSearch }) => {
  return (
    <input
      className="searchCancelBilling"
      placeholder="Buscar"
      type="search"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      style={{ backgroundColor: "whitesmoke" }}
    />
  );
};
export default SearchCancelBilling